import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import CustomButton from "../../../components/CustomButton";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../components/CustomTextField";
import {
  getPetsCompliantSummaryWoLoader,
  updateNoteByAppointmentIdWoLoader,
} from "../../../redux/reducers/petSlice";

const UpdateRemarks = ({
  remarksModVsble = false,
  onCloseRemarks,
  remarks = "",
  notes = "",
  id = null,
}) => {
  const dispatch = useDispatch();
  const [values, setValues] = useState({ remarks: "", notes: "" });

  useEffect(() => {
    setValues({ remarks, notes });
  }, [remarks, notes]);

  const onSaveRemarks = () => {
    dispatch(
      updateNoteByAppointmentIdWoLoader({
        id,
        note: values?.notes,
        remarks: values?.remarks,
      })
    ).then((res) => {
      if (res) {
        onCloseRemarks();
        dispatch(getPetsCompliantSummaryWoLoader(id));
      }
    });
  };

  return (
    <CustomModal
      open={remarksModVsble}
      onClose={onCloseRemarks}
      header="Remarks"
      modal
      modalWidth={50}
      headerBold
    >
      <CustomTextField
        name="remarks"
        fullWidth
        handleChange={(e) =>
          setValues({ ...values, remarks: e?.target?.value })
        }
        value={values?.remarks}
        multiline
      />
      <div className="flex1-center mv20">
        <div>
          <CustomButton text="Save" onClick={onSaveRemarks} smallBtn />
        </div>
      </div>
    </CustomModal>
  );
};

export default UpdateRemarks;
